export const loadInfo = reactive({
  primary_contact: {
    fullname: '',
    designation: '',
    email: '',
    mobiles: [],
    landlines: [],
  },
  alternative_contact: {
    fullname: '',
    designation: '',
    email: '',
    mobiles: [],
    landlines: [],
  },
})

export const loadersLoadsColumns = [
  {
    column_name: 'Load ID',
    column_value: 'id',
  },
  {
    column_name: 'Business Area',
    column_value: 'loaders_place_name',
    is_bold: true,
  },
  {
    column_name: 'Business Name',
    column_value: 'loaders_business_name',
  },
  {
    column_name: 'Loader ID',
    column_value: 'loader_id',
  },
  {
    column_name: 'Business Cluster',
    column_value: 'businessCluster',
  },
  {
    column_name: 'Trading Name',
    column_value: 'loaders_trading_name',
  },
  {
    column_name: 'Pri Name',
    column_value: '',
  },
  {
    column_name: 'Alt Name',
    column_value: '',
  },

  {
    column_name: 'FR + PR + OR + Misc',
    column_value: 'fr_pr_or',
  },
  {
    column_name: 'Pri Mobile No.',
    column_value: '',
  },
  {
    column_name: 'Alt Mobile No.',
    column_value: '',
  },
  {
    column_name: 'Adv + To Pay + POD',
    column_value: 'delivery',
  },
  {
    column_name: 'Loading Mobile No.',
    column_value: '',
  },
  {
    column_name: 'Loading Charges',
    column_value: '',
  },
  {
    column_name: 'Loading Points',
    column_value: '',
    is_bold: true,
  },
  {
    column_name: 'Unloading Mobile No.',
    column_value: '',
  },
  {
    column_name: 'Unloading Charges',
    column_value: '',
  },
  {
    column_name: 'Unloading Points',
    column_value: '',
    is_bold: true,
  },
  {
    column_name: 'Conditions',
    column_value: 'conditions',
  },
  {
    column_name: 'Freight Method',
    column_value: 'freight_method',
  },
  {
    column_name: 'Capacity',
    column_value: 'capacity',
    is_bold: true,
  },
  {
    column_name: 'Industry',
    column_value: 'load_industry',
  },
  {
    column_name: 'Materials / Products',
    column_value: 'load_material',
  },
  {
    column_name: 'Loading Date',
    column_value: 'loading_date',
    is_bold: true,
  },
  {
    column_name: 'Created Timestamp',
    column_value: 'created_at',
  },
  {
    column_name: '',
    column_value: '',
  },
  {
    column_name: 'Status',
    column_value: 'status',
  },
  {
    column_name: 'Updated Timestamp',
    column_value: 'updated_at',
  },
  {
    column_name: 'Notes',
    column_value: 'note',
  },
  {
    column_name: 'Remarks',
    column_value: 'remark',
    condition: (column_name: string, column_value: string) => column_name === 'Status' && column_value === 'Cancelled',
  },
]

export const loaderLoadColumns = [
  { name: 'Loader ID', value: 'id' },
  { name: 'Business Name', value: 'business_name' },
  { name: 'Trading Name', value: 'trading_name' },
  { name: 'Industry', value: 'industry' },
  { name: 'Business Area', value: 'place_name' },
  { name: 'Business GST IN', value: 'gst' },
  { name: 'Materials/Product', value: 'product' },
  { name: 'Email ID', value: 'email' },
  { name: 'Website', value: 'web' },
]

export const hybridLoadColumns = [
  { name: 'Hybrid User ID', value: 'id' },
  { name: 'Business Name', value: 'business_name' },
  { name: 'Trading Name', value: 'trading_name' },
  { name: 'Business Area', value: 'place_name' },
  { name: 'Business GST IN', value: 'gst' },
  { name: 'Designation', value: 'designation' },
  { name: 'Email ID', value: 'email' },
  { name: 'Website', value: 'web' },
  { name: 'Mobile No.', value: 'mobiles' },
]

export const loadPaymentInfo: Record<string, string> = {
  freight: 'Freight',
  pr: 'PR',
  or: 'OR',
  amount: 'Amount',
  amountPayment: 'AmountPayment',
  units: 'Units',
  tons: 'Tons',
  perTon: 'per_ton',
  perUnit: 'per_unit',
  totalFreight: 'total_freight',
  freightMethod: 'freight_method',
  perUnitQuantity: 'per_unit_quantity',
  freightPrAmount: 'freight_pr_amount',
  totalAmount: 'totalAmount',
  freightMethodTitle: 'Freight Method',
  freightAmount: 'freight_amount',
  prAmount: 'pr_amount',
  orAmount: 'or_amount',
  totalAmountTitle: 'Total Amount',
  misc: 'Misc',
  additional_charges: 'additional_charges',
}

export const loadsStatus = [
  { text: 'Available', value: 'Available' },
  { text: 'In process', value: 'In process' },
  { text: 'Expiring', value: 'Expiring' },
  { text: 'Expired', value: 'Expired' },
  { text: 'Cancelled', value: 'Cancelled' },
  { text: 'All', value: '' },
]

export const loadSearchFields: any = reactive({
  id: '',
  business_area: '',
  businessName: '',
  trading_name: '',
  primary_fullname: '',
  preferred_contact: '',
  cluster_place_name: null,
  alternative_fullname: '',
  alternative_mobiles: '',
  industry_load_material_industry: null,
  load_material_industry: null,
  conditions: null,
  capacity: '',
  loading_place_name: '',
  unloading_place_name: '',
  loading_charges: '',
  unloading_charges: '',
  loading_mobiles: '',
  unloading_mobiles: '',
  freight_method: null,
  loading_date: null,
  status: '',
  is_public: null,
  remark: null,
  targeted_route_id: null,
})
